<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Consulta de Solicitudes de Renuncia al Ahorro" description="" />
      <RenounceSavingRequested/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RenounceSavingRequested from '@/components/RenounceSaving/RenounceSavingRequested.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'RenounceSavingRequestedView',
  components: {
    RenounceSavingRequested,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>